<template>
  <l-icon
    :icon-size="[20, 33]"
    :icon-anchor="[12, 41]"
    :icon-url="iconUrl"
  >
  </l-icon>
</template>
<script>
import { LIcon } from "@vue-leaflet/vue-leaflet";

export default {
  name: "LIconPosteLivraison",
  components: {
    LIcon
  },
  data() {
    return {
      iconUrl: require("../../assets/img/marker-icon-2x-green.png")
    }
  }
};
</script>
